/**
 * Custom error class for API responses that carries HTTP status and field-level errors.
 * Replaces the pattern of casting `new Error(msg) as Error & { status: number }`.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly fieldErrors?: Array<{ field: string; message: string }>;

  constructor(message: string, status: number, fieldErrors?: Array<{ field: string; message: string }>) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.fieldErrors = fieldErrors;
  }
}

/** Type guard to check if an unknown error is an ApiError */
export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
